let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "运营商名称",
    props: "dealName",
    minWidth: 200,
  },
  {
    label: "电站名称",
    props: "stationName",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "电站地址",
    props: "stationAddr",
    minWidth: 180,
    tooltip: true,
  },
  {
    label: "电站ID",
    props: "stationNo",
    minWidth: 180,
  },
  {
    label: "充电桩数量",
    props: "totalPileCount",
    minWidth: 100,
  },
  {
    label: "异常桩数量",
    props: "errorPileCount",
    minWidth: 100,
  },
  {
    label: "资费（元）",
    props: "ttlVal",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.ttlVal) {
        return row.ttlVal;
      } else {
        return "0";
      }
    },
  },
  {
    label: "运营状态",
    props: "stationStatusName",
    minWidth: 120,
  },
  {
    label: "充电量",
    props: "totalChargeCount",
    minWidth: 100,
    sortable: true,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "商城管理",
    router: "commodityList",
  },

  {
    type: "title",
    name: "商品列表",
  },
];

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "商城管理",
    router: "commodityList",
  },
  {
    type: "title",
    name: "商品列表",
  },
  {
    type: "title",
    name: "发布商品",
  },
];

// 详情预览面包屑
pageConfig.preview = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "商城管理",
    router: "commodityList",
  },
  {
    type: "title",
    name: "详细信息",
  },
];

// 详情预览面包屑
pageConfig.previewUrl = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: "商城管理",
    router: "commodityList",
  },
  {
    type: "title",
    name: "URL导入",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 15, 20, 50],
};

pageConfig.rules = {
  commodityName: [
    { required: true, message: "请输入商品名称", trigger: "blur" },
  ],
  shelvesDisplayPictureUrl: [
    { required: true, message: "请选择货架展示图", trigger: "blur" },
  ],
  listDisplayPictureUrl: [
    { required: true, message: "请选择列表展示图", trigger: "blur" },
  ],

  commodityCarouselPictureUrl: [
    { required: true, message: "请选择轮播图", trigger: "blur" },
  ],
  commodityMainPictureUrl: [
    { required: true, message: "请选择商品主图", trigger: "blur" },
  ],
  commodityPrice: [{ required: true, message: "请输入价格", trigger: "blur" }],
  commodityNo: [{ required: true, message: "请输入商品编码", trigger: "blur" }],
  commodityType: [
    { required: true, message: "请选择上架设置", trigger: "blur" },
  ],
};
// listDisplayPictureUrl: [], //列表展示图
// commodityCarouselPictureUrl: [], //轮播图
// commodityMainPictureUrl: [], //商品主图
export default pageConfig;
